// @flow

import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';
import { Alert, Base } from '@gandi/ui';

import { Fieldset, Form, FormField, InputTextField } from 'gandi.react-form';

import type { AuthInfoFormValues } from '../types';

export type AuthInfoFormProps = {
  translator: TranslatorProps,

  initialValues: {
    authinfo: string,
  },
  error?: { [key: string]: string, ... },
  // eslint-disable-next-line react/no-unused-prop-types
  onSubmit: (data: AuthInfoFormValues) => Promise<void>,
  handleSubmit?: () => Promise<any>,
  submitFailed?: boolean,
};

export default class AuthInfoForm extends React.Component<AuthInfoFormProps> {
  static FORM_ID: string = 'authinfo-form';

  renderField: (props: any) => React.Node = props => {
    const {
      translator: { __ },
    } = this.props;
    const showError =
      !!props.meta.error && (props.meta.touched || this.props.submitFailed);

    return (
      <Fieldset error={showError}>
        <InputTextField name="authinfo" label={__('Authinfo code')} />
      </Fieldset>
    );
  };

  render(): React.Node {
    const {
      translator: { __ },
    } = this.props;

    return (
      <Form
        id={AuthInfoForm.FORM_ID}
        method="post"
        onSubmit={this.props.handleSubmit}
        className="form-stacked"
        noValidate
      >
        {this.props.error && (
          <Base marginBottom="base">
            <Alert
              intent="danger"
              title={__('Error')}
              message={this.props.error}
            />
          </Base>
        )}

        <FormField name="authinfo" component={this.renderField} />
      </Form>
    );
  }
}
